export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/tenaris',
  facebook: 'https://www.facebook.com/TenarisEvents/',
  x: 'https://x.com/tenaris',
  youtube: 'https://www.youtube.com/tenaris',
  linkedin: 'https://www.linkedin.com/company/tenaris',
  tenaris: 'https://www.tenaris.com/',
  termsEN: 'https://www.tenaris.com/en/legal',
  termsES: 'https://www.tenaris.com/es/legal'
};